import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from '@nuxtjs/composition-api';
import { ProductExtended } from '@webplatform/frontkit/dist/types';
import type { Product } from '@webplatform/nuxt-cms-js-sdk';
import { CdnImg } from '@webplatform/cdn-image';
import { useFetchProducts } from '~/composables';
import { getProductContent } from '~/helpers/vue';
import { handleImageSrc, handleImageAlt } from '~/helpers';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

interface Props {
  data?: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryRecommendedProducts',
  props: {
    data: { default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { data: any };



const { fetchProductsByIds } = useFetchProducts();
const items = ref<ProductExtended[]>([]);

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
};

const setupProduct = (product: Product): ProductExtended => {
  return {
    ...product,
    description: getProductContent(product).description,
    tags: getProductContent(product).tags,
    image: getProductContent(product).image,
  } as ProductExtended;
};

watch(
  () => props.data.productIds,
  async (ids) => {
    if (!ids?.length) return;
    try {
      const data = await fetchProductsByIds(ids as string[]);
      if (data) items.value = data.map(setupProduct);
    } catch (e) {}
  },
  { immediate: true },
);

return { __sfc: true,props, fetchProductsByIds, items, swiperOptions, setupProduct, CdnImg, handleImageSrc, handleImageAlt, Swiper, SwiperSlide }
}

})